/**
 * Keeps the mini-cart-modal prices in sync after quantity changes.
 * The modal clones cart-drawer content on open, but cloned elements
 * don't update when the original cart-drawer re-renders.
 * This script updates prices directly from the cart JSON response.
 */
(function () {
  "use strict";

  /**
   * Replaces only the numeric price value inside an element's text,
   * preserving the currency symbol/code and formatting.
   * E.g. "€25,00 EUR" with cents=5000 → "€50,00 EUR"
   */
  function updatePriceText(el, cents) {
    if (!el) return;

    // Get only the visible text (exclude sr-only spans)
    var srSpan = el.querySelector(".sr-only");
    var visibleNodes = [];
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node === srSpan) continue;
      if (node.nodeType === 3) visibleNodes.push(node); // text node
      if (node.nodeType === 1 && node !== srSpan) visibleNodes.push(node);
    }

    // Find the text node or element containing the price number
    var priceRegex = /[\d.,]+[.,]\d{2}/;
    for (var j = 0; j < visibleNodes.length; j++) {
      var textNode = visibleNodes[j];
      var text = textNode.textContent;
      var match = text.match(priceRegex);
      if (match) {
        // Format the new value matching the existing decimal separator
        var usesComma = match[0].indexOf(",") > match[0].lastIndexOf(".");
        var newValue = (cents / 100).toFixed(2);
        if (usesComma) {
          // Convert 1234.56 to 1.234,56 or 1234,56
          var parts = newValue.split(".");
          var intPart = parts[0];
          var decPart = parts[1];
          // Add thousand separator if original had one
          if (match[0].match(/\d{1,3}\.\d{3}/)) {
            intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
          newValue = intPart + "," + decPart;
        } else {
          // Keep dot decimal, add comma thousands if original had them
          if (match[0].match(/\d{1,3},\d{3}/)) {
            var parts2 = newValue.split(".");
            parts2[0] = parts2[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            newValue = parts2.join(".");
          }
        }
        textNode.textContent = text.replace(match[0], newValue);
        return;
      }
    }
  }

  function updateMiniCartModal(cart) {
    var modal = document.getElementById("mini-cart-modal");
    if (!modal || modal.style.display === "none") return;

    var modalBody = document.getElementById("mini-cart-modal-body");
    var modalBottom = document.getElementById("mini-cart-modal-bottom");
    var items = cart.items || [];

    // --- Update line item prices inside the modal ---
    if (modalBody) {
      items.forEach(function (item) {
        var input = modalBody.querySelector(
          '.quantity-input[data-line-key="' + item.key + '"]',
        );
        if (!input) return;

        var lineItemEl = input.closest("line-item, .line-item");
        if (!lineItemEl) return;

        // Update quantity display
        var qtyDisplay = lineItemEl.querySelector(".line-item__qty-value");
        if (qtyDisplay) qtyDisplay.textContent = item.quantity;

        // Update input value
        input.value = item.quantity;
        input.defaultValue = item.quantity;

        // Update sale price (only the numeric value)
        updatePriceText(
          lineItemEl.querySelector("sale-price"),
          item.final_line_price,
        );

        // Update compare-at price
        var compareEl = lineItemEl.querySelector("compare-at-price");
        if (item.original_line_price > item.final_line_price) {
          if (compareEl) {
            updatePriceText(compareEl, item.original_line_price);
            compareEl.style.display = "";
          }
        } else if (compareEl) {
          compareEl.style.display = "none";
        }

        // Update single/multi quantity stepper state
        var stepper = lineItemEl.querySelector(".line-item__quantity-stepper");
        if (stepper) {
          if (item.quantity === 1) {
            stepper.classList.add("line-item__quantity-stepper--single");
          } else {
            stepper.classList.remove("line-item__quantity-stepper--single");
          }
        }
      });

      // Hide removed items
      var allInputs = modalBody.querySelectorAll(
        ".quantity-input[data-line-key]",
      );
      for (var i = 0; i < allInputs.length; i++) {
        var key = allInputs[i].getAttribute("data-line-key");
        var found = items.some(function (it) {
          return it.key === key;
        });
        if (!found) {
          var lineEl = allInputs[i].closest("line-item, .line-item");
          if (lineEl) lineEl.remove();
        }
      }

      // If cart is empty, show empty state
      if (items.length === 0) {
        modalBody.innerHTML =
          '<div class="empty-state align-self-center" style="padding:2rem;text-align:center;"><p>' +
          (window.themeVariables?.strings?.cartEmpty || "Your cart is empty") +
          "</p></div>";
        if (modalBottom) modalBottom.innerHTML = "";
      }
    }

    // --- Update total price in modal bottom (only numeric value) ---
    if (modalBottom && items.length > 0) {
      var priceEls = modalBottom.querySelectorAll(".cart-drawer__price");
      if (priceEls.length >= 2) {
        updatePriceText(priceEls[priceEls.length - 1], cart.total_price);
      }
    }

    // --- Update cart count badges everywhere ---
    var countEls = document.querySelectorAll("cart-count");
    for (var k = 0; k < countEls.length; k++) {
      countEls[k].textContent = cart.item_count;
    }
  }

  document.addEventListener("cart:change", function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    updateMiniCartModal(cart);
  });

  document.addEventListener("variant:add", function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    updateMiniCartModal(cart);
  });
})();
